import { textInputType } from './FormFieldTypes';

export default function getInternalNotesField(
  hasSystemAdminAccess: boolean,
): textInputType {
  return {
    placeholder: 'Internal Notes',
    label: 'Internal Notes',
    multiline: true,
    name: 'internalNotes',
    type: 'textInput',
    required: false,
    hidden: !hasSystemAdminAccess,
  };
}
